import Service from "./general";
import { XML2JSON } from "../scripts/Treatment";
import { timeBegin, hour, timeEnd } from "../scripts/date";

const indicators = "99,100,101,102,103,369";
const indicatorWindDirection = "101";
const indicatorWindSpeed = "102";

const URL_NOW = `https://sensor.krasn.ru/sc/api/1.0/projects/6/aggvalues?&sites=4203&key=f6q6kbspmw7p47gr&time_begin=${timeBegin} ${hour}:00:00&time_end=${timeEnd} 23:00:00&time_interval=1hour&indicators=${indicators}`;
const URL_LAST = `https://sensor.krasn.ru/sc/api/1.0/projects/6/aggvalues?&sites=4203&key=f6q6kbspmw7p47gr&time_begin=${timeEnd} 00:00:00&time_end=${timeEnd} 23:00:00&time_interval=20min&indicators=${indicators}`;
const URL_WIND_DIRECTION = `https://sensor.krasn.ru/sc/api/1.0/projects/6/aggvalues?&sites=4203&key=f6q6kbspmw7p47gr&time_begin=${timeBegin} 00:00:00&time_end=${timeEnd} 23:00:00&time_interval=1hour&indicators=${indicatorWindDirection}`;
const URL_WIND_SPEED = `https://sensor.krasn.ru/sc/api/1.0/projects/6/aggvalues?&sites=4203&key=f6q6kbspmw7p47gr&time_begin=${timeBegin} 00:00:00&time_end=${timeEnd} 23:00:00&time_interval=1hour&indicators=${indicatorWindSpeed}`;

const informationServiceNow = new Service({ url: URL_NOW, func: XML2JSON });
const informationServiceLast = new Service({ url: URL_LAST, func: XML2JSON });
const informationServiceWindDirection = new Service({ url: URL_WIND_DIRECTION, func: XML2JSON });
const informationServiceWindSpeed = new Service({ url: URL_WIND_SPEED, func: XML2JSON });

export { informationServiceNow, informationServiceLast, informationServiceWindDirection, informationServiceWindSpeed };
